import { createSlice } from "@reduxjs/toolkit";
import { generateMessage } from "../conversation/conversationSlice";
/** Fields every caller receives; everything else on the response is debug-only. */
const PUBLIC_RESULT_KEYS = new Set(["message", "engine", "capped_message_id"]);
const initialState = {
    lastTurn: null,
    previousTurn: null,
};
const convertToEpochMs = (value) => (value instanceof Date ? value.getTime() : value);
/** `null` when the response carries no debug field (caller lacks `debug_chat`). */
export function toChatDebugTurn(result, receivedAt) {
    const sections = {};
    for (const [key, value] of Object.entries(result)) {
        if (!PUBLIC_RESULT_KEYS.has(key) && key !== "rulebook" && value !== undefined) {
            sections[key] = value;
        }
    }
    const rulebook = result["rulebook"];
    if (rulebook === undefined && Object.keys(sections).length === 0) {
        return null;
    }
    const messageCreatedAt = convertToEpochMs(result.message?.createdAt);
    return {
        conversationId: result.message?.conversation_id,
        messageId: result.message?.id,
        ...(result.message?.content !== undefined ? { deliveredText: result.message.content } : {}),
        ...(messageCreatedAt !== undefined ? { messageCreatedAt } : {}),
        ...(result.engine !== undefined ? { engine: result.engine } : {}),
        receivedAt,
        ...(rulebook !== undefined ? { rulebook } : {}),
        sections,
    };
}
export const chatDebugSlice = createSlice({
    name: "chatDebug",
    initialState,
    reducers: {
        clearChatDebug: (state) => {
            state.lastTurn = null;
            state.previousTurn = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(generateMessage.fulfilled, (state, action) => {
            const turn = toChatDebugTurn(action.payload, Date.now());
            if (turn !== null) {
                const isSameConversation = state.lastTurn !== null && state.lastTurn.conversationId === turn.conversationId;
                state.previousTurn = isSameConversation ? state.lastTurn : null;
                state.lastTurn = turn;
            }
        });
    },
});
export const { clearChatDebug } = chatDebugSlice.actions;
export default chatDebugSlice.reducer;
